import React from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../../common/SafeIcon';

const Maintenance = () => {
  const features = [
    {
      icon: FiIcons.FiMonitor,
      title: 'Mantenimiento Preventivo',
      description: 'Revisiones periódicas para prevenir fallos y optimizar el rendimiento de sus equipos.'
    },
    {
      icon: FiIcons.FiTool,
      title: 'Soporte Técnico',
      description: 'Asistencia remota y presencial para resolución de incidencias.'
    },
    {
      icon: FiIcons.FiServer,
      title: 'Gestión de Servidores',
      description: 'Administración y mantenimiento de servidores físicos y virtuales.'
    },
    {
      icon: FiIcons.FiHardDrive,
      title: 'Copias de Seguridad',
      description: 'Implementación y gestión de sistemas de backup automatizados.'
    }
  ];

  return (
    <div className="py-16 relative">
      <div className="max-w-7xl mx-auto px-4">
        <h1 className="text-4xl font-bold text-center mb-12">Mantenimiento Informático</h1>

        <div className="mb-12">
          <p className="text-lg text-gray-600 mb-6">
            Ofrecemos un servicio integral de mantenimiento informático diseñado para mantener su infraestructura tecnológica en óptimas condiciones, previniendo problemas y maximizando el tiempo de actividad.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-8 mb-12">
          {features.map((feature, index) => (
            <div key={index} className="bg-white p-6 rounded-lg shadow-lg">
              <SafeIcon icon={feature.icon} className="h-12 w-12 text-blue-600 mb-4" />
              <h3 className="text-xl font-semibold mb-2">{feature.title}</h3>
              <p className="text-gray-600">{feature.description}</p>
            </div>
          ))}
        </div>

        <div className="bg-blue-50 p-8 rounded-lg">
          <h2 className="text-2xl font-semibold mb-4">¿Por qué elegir nuestro servicio?</h2>
          <ul className="space-y-4">
            <li className="flex items-center">
              <SafeIcon icon={FiIcons.FiCheck} className="h-5 w-5 text-blue-600 mr-3" />
              <span>Monitorización proactiva 24/7</span>
            </li>
            <li className="flex items-center">
              <SafeIcon icon={FiIcons.FiCheck} className="h-5 w-5 text-blue-600 mr-3" />
              <span>Tiempo de respuesta garantizado</span>
            </li>
            <li className="flex items-center">
              <SafeIcon icon={FiIcons.FiCheck} className="h-5 w-5 text-blue-600 mr-3" />
              <span>Técnicos certificados</span>
            </li>
            <li className="flex items-center">
              <SafeIcon icon={FiIcons.FiCheck} className="h-5 w-5 text-blue-600 mr-3" />
              <span>Informes mensuales detallados</span>
            </li>
          </ul>
        </div>
      </div>

      {/* Botón para volver arriba */}
      <button
        onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
        className="fixed bottom-6 right-6 bg-blue-600 text-white p-3 rounded-full shadow-lg hover:bg-blue-700 transition-all z-50"
        aria-label="Volver arriba"
      >
        <SafeIcon icon={FiIcons.FiArrowUp} className="h-6 w-6" />
      </button>
    </div>
  );
};

export default Maintenance;